export const defaultSignalData = [
  {
    id: 1,
    server_id: 1,
    target_id: 1,
    frequency: 4810,
    power: -100,
    bandwidth: 10,
    modulation: '8QAM',
    fec: '3/4',
    feed: 'red 1.mp4',
    operational: false,
  },
  {
    id: 2,
    server_id: 1,
    target_id: 1,
    frequency: 4798,
    power: -96,
    bandwidth: 10,
    modulation: '8QAM',
    fec: '3/4',
    feed: 'blue 1.mp4',
    operational: false,
  },
  {
    id: 3,
    server_id: 1,
    target_id: 1,
    frequency: 4817,
    power: -93,
    bandwidth: 2,
    modulation: '8QAM',
    fec: '3/4',
    feed: 'blue 1.mp4',
    operational: false,
  },
  {
    id: 4,
    server_id: 1,
    target_id: 1,
    frequency: 4826,
    power: -86,
    bandwidth: 1,
    modulation: '8QAM',
    fec: '3/4',
    feed: 'blue 1.mp4',
    operational: false,
  },
  {
    id: 5,
    server_id: 1,
    target_id: 1,
    frequency: 4785,
    power: -90,
    bandwidth: 4,
    modulation: '8QAM',
    fec: '3/4',
    feed: 'blue 1.mp4',
    operational: false,
  },
  {
    id: 6,
    server_id: 1,
    target_id: 1,
    frequency: 4833,
    power: -110,
    bandwidth: 10,
    modulation: 'BPSK',
    fec: '1/4',
    feed: 'blue 1.mp4',
    operational: false,
  },
];
